// src/components/GoogleLogin.jsx
import React from 'react';
import { GoogleLogin } from '@react-oauth/google';

const GoogleLoginButton = ({ onSuccess, onFailure, loading = false }) => {
  const handleSuccess = (credentialResponse) => {
    if (credentialResponse.credential) {
      const userInfo = parseJWT(credentialResponse.credential);
      
      const googleResponse = {
        tokenId: credentialResponse.credential,
        profileObj: {
          email: userInfo.email,
          name: userInfo.name,
          picture: userInfo.picture,
          googleId: userInfo.sub
        }
      };
      
      onSuccess(googleResponse);
    } else {
      onFailure(credentialResponse);
    }
  };

  const parseJWT = (token) => {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error('Erreur lors du décodage du token JWT:', error);
      return {};
    }
  };

  return (
    <div style={{ marginBottom: "15px" }}>
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={() => onFailure({ error: 'Google Login Failed' })}
        useOneTap={false}
        shape="rectangular"
        size="large"
        width="100%"
        theme="outline"
        text="continue_with"
        disabled={loading}
        style={{
          width: "100%",
          borderRadius: "10px",
        }}
      />
    </div>
  );
};

export default GoogleLoginButton;